module.exports = __webpack_public_path__ + "static/media/google-pay.5f0a9052.svg";